<script>
import mainServices from '../../components-manual/molecules/mainServices.vue';
import Advantages from '../../components-manual/molecules/Advantages.vue';
import CardsFormV2 from '../../components-manual/cards/CardsFormV2.vue';
import CardsStartCreditForm from '../../components-manual/cards/credit/CardsStartCreditForm.vue';
import StickerForm from '../../components-manual/cards/StickerForm.vue';
import '/local/templates/redesign/src/assets/scss/block/cards-grace-periods.scss';
import '../../assets/scss/block/cards-cashback.scss';
import UiTabSwitcher from '../../components/ui/UiTabSwitcher.vue';
import InterlinkingPages from '../../components-manual/molecules/InterlinkingPages.vue';
import { DButton } from '@ahml/domrfbank-ui/elements/DButton';
import { DTabs } from '@ahml/domrfbank-ui/elements/DTabs';

export default {
    components: {
        mainServices,
        Advantages,
        CardsFormV2,
        CardsStartCreditForm,
        StickerForm,
        UiTabSwitcher,
        InterlinkingPages,
        DButton,
        DTabs
    },
};
</script>
